export default __webpack_public_path__ + "static/media/share.df7c01af.svg";